export const iconFontAwesomeTravelHotelTaxi = (
	<i className="fa-solid fa-taxi"></i>
);
